import { Colors } from '../Colors';

export default {
    styles: {
        body: {
            color: Colors.text,
        },
    },
};
